import React, { useEffect, useState } from 'react';
// import 'antd/dist/antd.css';
import { Table, Radio, message, Spin, Modal, Button, Row, Col, Card } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import efn from './LinkFns'
import langObj from '../TopUserLang'
import './Link.scss';
import DraggableTable from './DraggableTable'

function Link(props) {
  const navigate = useNavigate()
  const location = useLocation()
  const [links, setLinks] = useState([])
  const [isPageLoading, setIsPageLoading] = useState(true)
  const [isTableLoading, setIsTableLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [modalTitle, setModalTitle] = useState("")
  const [modalContent, setModalContent] = useState()
  const [cnSortChange, setCnSortChange] = useState([])
  const [enSortChange, setEnSortChange] = useState([])
  const [isButtonSortLoading, setIsButtonSortLoading] = useState(false)
  const [cnLinks, setCnLinks] = useState([])
  const [mode, setMode] = useState('All');
  const handleModeChange = (e) => {
    setMode(e.target.value);
  };
  const setFuncMap = {
    setLinks, setIsPageLoading, setIsModalOpen,
    setIsTableLoading, setModalTitle, setModalContent,
    message, setCnSortChange, setEnSortChange, setIsButtonSortLoading
  }
  const columns = efn.generateLinkMenu(props, setFuncMap)
  const moveColumns = efn.generateLinkMoveMenu(props, setFuncMap)
  useEffect(() => {
    setCnLinks(efn.getLangSortedLinks(links, "CN"))
  }, [links])

  // let cnLinks = efn.getLangSortedLinks(Links, "CN")
  let enLinks = efn.getLangSortedLinks(links, "EN")
  useEffect(() => {

    efn.getLinks(props, setFuncMap)
    efn.getConference(props, setFuncMap)

  }, []);

  return (
    <Spin spinning={isPageLoading}>
      <div className="Link">
        <Row gutter={16} justify="end">
          {mode === "CN" && cnSortChange.length > 0 && <Col>
            <Button type="primary" loading={isButtonSortLoading}
              onClick={() => { efn.updateLinksSort(mode, cnSortChange, props, setFuncMap) }}>更新排序</Button>
          </Col>}
          {mode === "EN" && enSortChange.length > 0 && <Col>
            <Button type="primary" loading={isButtonSortLoading}
              onClick={() => { efn.updateLinksSort(mode, enSortChange, props, setFuncMap) }}>更新排序</Button>
          </Col>}
          <Col>
            <Button type="primary" onClick={() => { efn.openLinkCreatePage(props.conferenceUid, "建立連結", setFuncMap) }}>建立連結</Button>
          </Col>
        </Row>
        <Spin spinning={isTableLoading}>
          <Radio.Group
            onChange={handleModeChange}
            value={mode}
            style={{
              marginBottom: 8,
            }}
          >
            {langObj.langsWithAll.map((lang, key) => {
              return <Radio.Button key={key} value={lang.key} style={{ background: lang.color }}>{lang.key}</Radio.Button>
            })}
          </Radio.Group>
          {mode === "All" && <Table dataSource={links} columns={columns} />}
          {mode === "EN" && <DraggableTable dataSource={enLinks}
            columns={moveColumns}
            setFuncMap={setFuncMap}
            mode="EN" />}
          {mode === "CN" && <DraggableTable dataSource={cnLinks}
            columns={moveColumns}
            setFuncMap={setFuncMap}
            mode="CN" />}

        </Spin>
        <Modal wrapClassName="modal-theme" width="80%" title={modalTitle} open={isModalOpen} footer={[]} destroyOnClose
          onCancel={() => { setIsModalOpen(false) }}>
          {modalContent}
        </Modal>
      </div>
    </Spin>
  );
}



export default Link;
